import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../ProfileCommon/Breadcrumb";
import NewHeader from "../../Home/NewHeader";
import BadgeCard from "../ProfileCommon/BadgeCard";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import images from "../../../images";
import { useGetUserInfoQuery } from "../../../services/apiSlice";

const badges = [
  {
    level: 1,
    xp: 20,
    coin: 500,
    image: images.BadgeLevel1,
  },
  {
    level: 2,
    xp: 20,
    coin: 800,
    image: images.BadgeLevel1,
  },
  {
    level: 3,
    xp: 50,
    coin: 1300,
    image: images.BadgeLevel1,
  },
  {
    level: 4,
    xp: 20,
    coin: 800,
    image: images.BadgeLevel1,
  },
  {
    level: 5,
    xp: 50,
    coin: 1800,
    image: images.BadgeLevel1,
  },
  {
    level: 6,
    xp: 20,
    coin: 800,
    image: images.BadgeLevel1,
  },
];

const Badges = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: userInfo } = useGetUserInfoQuery();

  useEffect(() => {
    if (userInfo?.data?.id) {
      localStorage.setItem("customUserId", userInfo.data.id);
      localStorage.setItem("userInfo", JSON.stringify(userInfo.data));
    }
  }, [userInfo]);

  return (
    <div className="flex flex-col mx-auto w-full bg-white max-w-[480px] min-h-[912px]">
      <LoadingCommon />
      <div className=" fixed top-0 left-0 w-full z-50">
        <NewHeader />
      </div>
      <div className="h-[30px]"></div>
      <div className="flex flex-col flex-1 gap-6 py-3.5 px-[30px] mt-4">
        <Breadcrumb
          breadCrumbTiltle={t("badges.title")}
          onClickBack={() => navigate("/profile")}
        />
        <p className="text-[#253FF6] text-base font-medium">
          Earn badges based on your experience level, and you’ll unlock quests
          with higher rewards!
        </p>
        <div className="flex flex-col gap-6">
          {badges.map((badge, index) => {
            const userLevel = userInfo?.data?.level_object?.no;
            const isCompleted = badge.level === userLevel;
            const lastCompletedIndex = badges.findLastIndex(
              (badge) => badge.level === userLevel
            );

            const distance = index - lastCompletedIndex;
            let fadedLevel = 0;
            if (distance === 1) fadedLevel = 1; // mờ nhẹ
            else if (distance > 1) fadedLevel = 2; // mờ nhiều
            return (
              <BadgeCard
                key={index}
                isCompleted={isCompleted}
                level={badge.level}
                xp={badge.xp}
                coin={badge.coin}
                image={badge.image}
                isLast={index === badges.length - 1}
                fadedLevel={fadedLevel}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Badges;
